import React, {FC} from 'react';
import { inputProps as InputProps } from '../../types/types';

interface CheckboxProps extends InputProps {
    checked: boolean,
}

const Checkbox: FC<CheckboxProps> = ({
    checked,
    label,
    labelText,
    onChange,
    required,
    redHighlight,
    additionalClassNames,
    additionalNote,
    useLabelTextAsHtml,
    inputDisabled
}) => {

    let dangerousHtml = labelText;

    if (useLabelTextAsHtml && required) {
        dangerousHtml += `<span class="text-red-500 font-bold text-2xl">*</span>`;
    }

    return (
        <div className={
            "mb-3 w-full " + (additionalClassNames ?? "")
            + (redHighlight ? " required-highlight" : "").replace("  ", " ")}
        >
        <input
            id={label}
            name={label}
            type="checkbox"
            checked={checked}
            className="
                form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white
                checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition
                duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2
                cursor-pointer bg-gray-300
            "
            onChange={onChange}
            value=""
            disabled={inputDisabled ?? false}
        />
            {!useLabelTextAsHtml &&
            <label htmlFor={label}
                    className="form-check-label inline-block text-gray-800">
                {labelText}
                {required &&
                    <span className="text-red-500 font-bold text-2xl">*</span>
                }
            </label>
            }
            {useLabelTextAsHtml &&
            <label htmlFor={label}
                className="form-check-label inline-block text-gray-800"
                dangerouslySetInnerHTML={{__html: dangerousHtml}}>
            </label>
            }
            {additionalNote !== undefined && <p>{additionalNote}</p>}
        </div>
    );
};

export default Checkbox;